<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-02-28 09:40:49
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div id="login">
    <div class="login_logo">
      <div class="img">
        <img src="@/assets/img/logosvg.svg" />
      </div>
      <div class="title">{{$t('system.txt1')}}</div>
    </div>
    <div class="login">
      <div class="language">
        <!-- <languageTranslation></languageTranslation> -->
      </div>
      <div id="login_lo">
        <div class="title2">{{$t('system.txt2')}}</div>
      </div>
      <div :class="msg == 1 ? 'system ok' : 'system'" @click="msg = 1">
        <img src="@/assets/img/a.png" class="system_logo" />{{$t('system.txt3')}}<img
          src="@/assets/img/dui.png"
          class="system_yes"
        />
      </div>
      <div :class="msg == 2 ? 'system ok' : 'system'" @click="msg = 2">
        <img src="@/assets/img/i.png" class="system_logo" />{{$t('system.txt4')}}<img
          src="@/assets/img/dui.png"
          class="system_yes"
        />
      </div>
      <div @click="goChoos()" class="loginButton">{{$t('system.txt5')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 1
    }
  },
  mounted () {},
  methods: {
    goChoos () {
      this.$router.push({ name: 'Choos', params: { type: this.msg } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(./../assets/img/login.png);
  background-size: 100% auto;
  color: #fff;
}
.login_logo {
  position: absolute;
  top: 45%;
  right: 70%;
}
.login_logo .img,
.login_logo .img img {
  width: 170px;
}
.login_logo .title {
  font-size: 16px;
  line-height: 50px;
}
.login {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -300px 0 0;
  background: #fff;
  border-radius: 20px;
}
.login .language {
  position: absolute;
  right: 20px;
  top: 20px;
  overflow: hidden;
}
.login .language .flag {
  border-radius: 8px;
}
.login .language .dow,
.login .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.login .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
#login_lo {
  width: 360px;
  margin: 0 auto;
  color: #000;
  text-align: left;
}
#login_lo .title {
  font-size: 32px;
  font-weight: 700;
  font-family: Noto Sans;
  margin: 60px 0 30px;
}
#login_lo .title2 {
  font-size: 24px;
  font-weight: 700;
  font-family: Noto Sans;
  line-height: 36px;
  margin: 60px 0 30px;
}
#login_lo .ftitle {
  font-size: 13px;
  font-family: Noto Sans;
  line-height: 20px;
  color: #9f9f9f;
  margin-bottom: 20px;
}
.login_input {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 10px;
  text-align: left;
  position: relative;
}
.login_input .login_input_title {
  font-size: 14px;
  line-height: 30px;
  color: #000;
}
.login_input input {
  height: 48px;
  width: 358px;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-indent: 1em;
  font-size: 14px;
  padding: 0;
}
.login_input input:focus {
  border: 1px solid #00eec3;
}
.login_input input.error {
  border: 1px solid #f54545;
}
.login_input_eye {
  position: absolute;
  bottom: 10px;
  right: 16px;
  width: 16px;
  height: 16px;
  bottom: 28px;
}
.loginButton {
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 90px auto 50px;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
}
.Tips {
  width: 360px;
  height: 16px;
  text-align: center;
  color: #f54545;
  font-size: 12px;
  margin: 0 auto 30px;
}
.login_a {
  font-size: 14px;
  text-align: center;
  color: #0080ff;
  display: block;
  margin-bottom: 0;
  line-height: 20px;
}
.tagging {
  font-size: 12px;
  text-align: center;
  color: #9f9f9f;
  display: block;
  line-height: 20px;
}
.explain {
  width: 360px;
  margin: 20px auto;
  color: #9f9f9f;
  text-align: left;
  font-size: 13px;
  line-height: 20px;
}
.explain img {
  float: left;
  width: 16px;
  height: 16px;
  margin: 0 6px 6px 0;
}
.explain a {
  color: #0080ff;
}
.system {
  height: 40px;
  padding: 25px 0;
  width: 358px;
  border: 1px solid #e1e3e6;
  border-radius: 10px;
  color: #000;
  text-align: left;
  font-size: 14px;
  line-height: 40px;
  margin: 0 auto 20px;
  cursor: pointer;
}
.system_logo {
  height: 40px;
  width: 40px;
  float: left;
  margin: 0 25px;
}
.system_yes {
  float: right;
  height: 20px;
  width: 20px;
  margin: 10px 25px;
  display: none;
}
.system.ok .system_yes {
  display: block;
}
.system.ok {
  border: 1px solid #00eec3;
}
</style>



// WEBPACK FOOTER //
// src/components/system.vue